(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.currentScrollTop = 0;
      this.scrollDelta = 6;
      this.revealAfter = 80;
      this.preventReveal = false;
    }

    connectedCallback() {
      this.header = this.closest('.container-header') || document.querySelector('.container-header');
      this.isTransparentHeader = this.classList.contains('header-wrapper--transparent');
      this.stickyType = this.getAttribute('data-sticky-type') || 'none';
      this.predictiveSearch = this.querySelector('predictive-search');

      if (!this.header) return;

      this.setHeaderHeight();
      this.currentScrollTop = window.scrollY || document.documentElement.scrollTop || 0;

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);

      if (this.isTransparentHeader) {
        this.applyTransparentState(this.currentScrollTop <= 10 ? 'transparent' : 'hidden');
      } else {
        this.initializeStandardStickyHeader();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    initializeStandardStickyHeader() {
      this.headerBounds = { bottom: this.header.offsetHeight, top: 0 };

      if (this.stickyType === 'always' || this.stickyType === 'reduce-logo-size') {
        this.header.classList.add('shopify-container-header-sticky');
      }
    }

    onScroll() {
      if (!this.header) return;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const scrollTop = Math.max(window.scrollY || document.documentElement.scrollTop || 0, 0);

      if (this.isTransparentHeader) {
        this.handleTransparentHeader(scrollTop);
      } else {
        this.handleStandardHeader(scrollTop);
      }

      this.currentScrollTop = scrollTop;
    }

    handleTransparentHeader(scrollTop) {
      const difference = scrollTop - this.currentScrollTop;

      if (scrollTop <= 10) {
        this.applyTransparentState('transparent');
        return;
      }

      if (Math.abs(difference) < this.scrollDelta) return;

      if (difference > 0) {
        this.applyTransparentState('hidden');
        this.closeMenuDisclosure();
        this.closeSearchModal();
        return;
      }

      if (scrollTop > this.revealAfter && !this.preventReveal) {
        this.applyTransparentState('sticky');
      }
    }

    applyTransparentState(state) {
      const states = ['rgd-header--transparent', 'rgd-header--hidden', 'rgd-header--sticky'];
      this.header.classList.remove(...states, 'scrolled-past-header', 'shopify-container-header-hidden');
      this.classList.remove(...states, 'scrolled-past-header');

      const stateClass = `rgd-header--${state}`;
      this.header.classList.add(stateClass);
      this.classList.add(stateClass);

      if (state === 'transparent') {
        this.header.classList.remove('shopify-container-header-sticky', 'animate');
      } else {
        this.header.classList.add('shopify-container-header-sticky');
        if (state === 'sticky') this.header.classList.add('animate');
      }
    }

    handleStandardHeader(scrollTop) {
      const alwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      const headerBottom = this.headerBounds?.bottom || this.header.offsetHeight;

      if (alwaysSticky) {
        this.header.classList.toggle('scrolled-past-header', scrollTop > headerBottom);
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        this.preventReveal ? this.hide() : this.reveal();
      } else if (scrollTop <= 0) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }
    }

    hide() {
      this.header.classList.add('shopify-container-header-hidden', 'shopify-container-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-container-header-sticky', 'animate');
      this.header.classList.remove('shopify-container-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-container-header-hidden', 'shopify-container-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
